import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment-timezone';

import MemberHeader from './parts/MemberHeader';
import MemberFooter from './parts/MemberFooter';

const ContributorDashboard = () => {
  const setApp = useDispatch();

  const data = window.pagedata;

  useEffect(() => {
    setApp({
      type: '_AUTH_LOGGED',
      payload: [window.auth.first_name, window.auth.last_name]
    });
  }, []);

  return (
    <>
      <section id="member-area">
        <MemberHeader title="Dashboard"/>
        <div id="breadcrumb">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-xs-12">
                <div className="breadcrumb-items">
                    <ul id="breadcrumbs" className="breadcrumbs">
                      <li>
                        <a
                          className="bread-link bread-home"
                          href="/"
                          title="Home"
                        >
                          Home/Map
                        </a>
                      </li>
                      <li>
                        <strong className="bread-current">Dashboard</strong>
                      </li>
                    </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="dashboard-card" className="container dashboard-card">
          <div className="row">
            <div className="col-sm-4">
              <div className="card">
                <div className="card-body">
                  <h1 className="card-title">{data.study_stat[0]}</h1>
                  <h5 className="card-text mb-4">
                    <i className="fa fa-eye"/> Total views of your datasets
                  </h5>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="card">
                <div className="card-body">
                  <h1 className="card-title">{data.study_stat[1]}</h1>
                  <h5 className="card-text mb-4">
                    <i className="fa fa-download"/> Total of your datasets downloaded
                  </h5>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="card">
                <div className="card-body">
                  <h1 className="card-title">{data.total_datasets}</h1>
                  <h5 className="card-text mb-4">
                    <i className="fa fa-file-archive-o"/> Total of your datasets
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="member-block-style">
          <div className="container">
            <div className="row">
              <div className="col">
                <h5 className="member-block-title">
                  <i className="fa fa-list"/> Your dataset{data.stat_studies.length > 1 ? 's' : ''}:
                </h5>
                <table className="table table-hover">
                  <thead className="thead-dark">
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Title</th>
                      <th scope="col" className="text-right">
                        <i className="fa fa-eye"/> Views
                      </th>
                      <th scope="col" className="text-right">
                        <i className="fa fa-download"/> Downloaded
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      data.stat_studies.map((d,i)=>{
                        return (
                          <tr key={d.title}>
                            <th scope="row">{i+1}</th>
                            <td>
                              {d.title}
                              <br />
                              <small>
                                I would like to be offered co-authorship on any publications using my Data
                              </small>
                            </td>
                            <td className="text-right">
                              {d.total_view || 0}
                            </td>
                            <td className="text-right">
                              {d.total_download || 0}
                            </td>
                          </tr>
                        )
                      })
                    }
                  </tbody>
                </table>
                <br/>
              </div>
            </div>
          </div>
        </div>

        <div className="member-block">
          <div className="container">
            <div className="row">
              <div className="col">
                <h5 className="member-block-title"><i className="fa fa-list"/> Your datasets download history:</h5>
                <table className="table table-hover">
                  <thead className="thead-dark">
                  <tr>
                    <th scope="col" style={{width:168}}>Datetime</th>
                    <th scope="col" style={{width:190}}>Downloaded by</th>
                    <th scope="col">Study title</th>
                  </tr>
                  </thead>
                  <tbody>
                  {
                    !data.contributor_downloads.length ? (
                      <tr>
                        <td colSpan="3">
                          <h6>Data not available yet.</h6>
                        </td>
                      </tr>
                    ) : null
                  }
                  {
                    data.contributor_downloads.map((d,i)=>{
                      return (
                        <tr key={i}>
                          <td>{moment.utc(d.downloadDatetime).tz(moment.tz.guess()).fromNow()}
                            <br/>
                            <small>
                              <b>{moment.utc(d.downloadDatetime).tz(moment.tz.guess()).format('D MMM YYYY')}</b> <i className="fa fa-clock-o"/> {moment.utc(d.downloadDatetime).tz(moment.tz.guess()).format('hh:mm a')}
                            </small>
                          </td>
                          <td>
                            <a href={`/member/account/${d.id}`}><b>{d.first_name} {d.last_name}</b></a>
                            {
                              d.affiliation ? (
                                <>
                                  <br/><small>{`(${d.affiliation})`}</small>
                                </>
                              ) : null
                            }
                          </td>
                          <td>{d.title}<br/><small>Permission: I would like to be offered co-authorship on any publications using my Data</small></td>
                        </tr>
                      )
                    })
                  }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div className="member-block-style">

          <div className="container">
            <div className="row">
              <div className="col">

                <h5 className="member-block-title"><i className="fa fa-list"/> Your download:</h5>
                <table className="table table-hover">
                  <thead className="thead-dark">
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Title</th>
                      {/*<th scope="col">Author(s)</th>*/}
                      <th scope="col">Type</th>
                      <th scope="col">Permission</th>
                    </tr>
                  </thead>
                  <tbody>
                  {
                    !data.my_downloads.length ? (
                      <tr>
                        <td colSpan="5">
                          <h6>Data not available yet.</h6>
                        </td>
                      </tr>
                    ) : null
                  }
                  {
                    data.my_downloads.map((d,i)=>{
                      return (
                        <tr key={i}>
                          <th scope="row">{i+1}</th>
                          <td>{d.title}<br/></td>
                          {/*<td>Coad L.</td>*/}
                          <td>{d.type}</td>
                          <td>24 months after Data are inputted into the WILDMEAT Database, and I would like to be offered co-authorship on any publications using Data contributed by me</td>
                        </tr>
                      )
                    })
                  }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <MemberFooter/>
      </section>
    </>
  )
};

export default ContributorDashboard;
